import React from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import styles from './style.module.scss';

const TextArea = props =>
	<TextareaAutosize
		className={styles.input}
		placeholder={props.placeholder}
		name={props.name}
		value={props.value}
		onChange={event => props.handleInput(event)}
		onBlur={event => props.handleInput(event)}
		autoComplete />

TextArea.defaultProps = {
	placeholder: ''
}

TextArea.propTypes = {
	name: PropTypes.string.isRequired,
	handleInput: PropTypes.func.isRequired,
	placeholder: PropTypes.string, 
}

export default TextArea;